import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { ORDER_FEATURE, OrderRootModule } from '@spartacus/order/root';

@NgModule({
    declarations: [],
    imports: [OrderRootModule],
    providers: [
        provideConfig({
            featureModules: {
                [ORDER_FEATURE]: {
                    module: () => import('@spartacus/order').then(m => m.OrderModule)
                }
            }
        } as CmsConfig),
    ]
})
export class SpartacusOrderFeatureModule {
}
